export default __webpack_public_path__ + "static/media/add.2accee5f.svg";